import { render, staticRenderFns } from "./AccessGuard.vue?vue&type=template&id=054bab38&scoped=true&"
import script from "./AccessGuard.vue?vue&type=script&lang=js&"
export * from "./AccessGuard.vue?vue&type=script&lang=js&"
import style0 from "./AccessGuard.vue?vue&type=style&index=0&id=054bab38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054bab38",
  null
  
)

export default component.exports